import { AxiosInstance } from 'axios';
import { ArgumentValidator } from '../../helpers';
import { QueryStringBuilder } from '../helpers';
import { IImpersonationSession, IImpersonationSessionReference, IPagedList, IPagination } from '../models';

export class ImpersonationClient {

    constructor(private axiosClient: AxiosInstance) { }

    public get apiUrl() {
        return `/impersonation`;
    }

    public async listRequested(pagination?: IPagination, waitForNonStaleResults: boolean = false): Promise<IPagedList<IImpersonationSession>> {

        const random = Math.ceil(Math.random() * 99999); // So IE won't cache this request

        const url = new QueryStringBuilder()
            .withPaginationIfNotEmpty(pagination)
            .withQueryIfNotEmpty('waitForNonStaleResults', waitForNonStaleResults)
            .withQueryIfNotEmpty('r', random)
            .build(`${this.apiUrl}/listRequested`);

        const response = await this.axiosClient.get(
            url
        );

        return response.data;

    }

    public async approve(guid: string): Promise<IImpersonationSessionReference> {

        ArgumentValidator.notNullOrEmpty(guid, 'guid');

        const response = await this.axiosClient.post(
            `${this.apiUrl}/approve/${guid}`
        );

        return response.data;
    }

    public async start(guid: string): Promise<IImpersonationSessionReference> {

        ArgumentValidator.notNullOrEmpty(guid, 'guid');

        const response = await this.axiosClient.post(
            `${this.apiUrl}/start/${guid}`
        );

        return response.data;
    }

    public async end(): Promise<void> {

        await this.axiosClient.post(
            `${this.apiUrl}/end`
        );
    }
}
